import { toast } from 'react-toastify';
import { Api } from '../lib/api/api';

export const getOobmBox = (token, paginateOptions,serverFilter) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'INCOMING_FAXES',
  });
  try {
    const OobmBox = await api.users.getOobmBox(paginateOptions,serverFilter);
    dispatch({
      type: 'OobmBox_SUCCESS' });
      return OobmBox;
  } catch (error) {
    dispatch({
      type: 'OobmBox_ERROR',
      error,
    });
  }
};